import { AxiosInstance } from 'axios';
import { KoddiAPIResponse } from 'types';
import { AlertsAPIResponse } from '../Recommendations/Recommendations.types';
import {
    BudgetRecommendationsByEntitiesPayload,
    AggregatedBudgetRecommendations,
    BudgetRecommendationsByAdvertiser,
    AdvertisersBudgetRecommendationPayload,
} from './KoddiRecommendations.types';

class KoddiRecommendationsAPI {
    protected axios: AxiosInstance;

    constructor(axios: AxiosInstance) {
        this.axios = axios;
    }

    getRecommendationsByAdvertiserId = async ({
        memberGroupId,
        advertiserId,
    }: {
        memberGroupId: string;
        advertiserId: string;
    }): Promise<AlertsAPIResponse & { advertiser_id: string }> => {
        const response = await this.axios.get<
            KoddiAPIResponse<AlertsAPIResponse & { advertiser_id: string }>
        >(
            `v1/member_groups/${memberGroupId}/advertisers/${advertiserId}/alerts`
        );
        return { ...response.data.result, advertiser_id: advertiserId };
    };

    // last one needs to be refactored to use the new API
    getBudgetRecommendationsByAdvertisers = async ({
        memberGroupId,
        experienceId,
        advertisers,
    }: AdvertisersBudgetRecommendationPayload): Promise<any> => {
        const response = await this.axios.post<
            KoddiAPIResponse<BudgetRecommendationsByAdvertiser>
        >(
            `v1/member_groups/${memberGroupId}/experiences/${experienceId}/advertisers/budget_recommendations`,
            {
                advertisers,
            }
        );

        return response.data.result;
    };

    // last use of this is in CampainWizardV3 and would take significant refactors to implement
    getBudgetRecommendationsByEntities = async ({
        memberGroupId,
        advertiserId,
        uuid,
        experienceId,
        budgetTypeId,
        startDate,
        endDate,
        targeting,
    }: BudgetRecommendationsByEntitiesPayload): Promise<{
        aggregated_budget_recommendation: AggregatedBudgetRecommendations;
    }> => {
        const response = await this.axios.post<
            KoddiAPIResponse<{
                aggregated_budget_recommendation: AggregatedBudgetRecommendations;
            }>
        >(
            `v1/member_groups/${memberGroupId}/advertisers/${advertiserId}/drafts/${uuid}/budget_recommendations`,
            {
                experience_id: experienceId,
                budget_type_id: budgetTypeId,
                start_date: startDate,
                end_date: endDate,
                targeting,
            }
        );

        return response.data.result;
    };
}

export default KoddiRecommendationsAPI;
